/**
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { createSlice } from '@reduxjs/toolkit';

/*-------------------------------------------------------------------------------------------*/

const { reducer, actions } = createSlice({
  name: 'summaryPilot',
  initialState: {
    items: [],
    result: []
  },
  reducers: {
    update(state, action) {
      state.items = action.payload;
    },
    updateResult(state, action) {
      state.result = action.payload;
    }
  }
});

/*-------------------------------------------------------------------------------------------*/

export { actions as summaryPilotAction };
export { reducer as summaryPilotReducer };

/*-------------------------------------------------------------------------------------------*/
